<template>
    <div>
        <CButton color="primary" class="mb-3" @click="openCreateModal">Добавить событие</CButton>

        <div v-if="events.length">
            <CRow v-for="(event) in events" :key="event.id" class="mb-2">
                <CCol sm="8">
                    <strong>{{ event.current_date_title }}</strong>
                    <ul>
                        <li v-for="(item, idx) in event.current_date_times" :key="idx">
                            {{ item.time }} - {{ item.text }}
                        </li>
                    </ul>
                </CCol>
                <CCol sm="4" class="text-right">
                    <CButton color="info" size="sm" @click="openEditModal(event)">Редактировать</CButton>
                    <CButton color="danger" size="sm" class="ml-2" @click="deleteEvent(event.id)">Удалить</CButton>
                </CCol>
            </CRow>
        </div>
        <div v-else>
            <p>Нет событий для отображения.</p>
        </div>

        <CModal
            :title="'Событие'"
            :show.sync="isModalOpen"
        >
            <AdsCampaignEventForm
                v-if="currentEvent"
                :event="currentEvent"
            />

            <div slot="footer">
                <CButton color="success" @click="handleSave(currentEvent)">Сохранить</CButton>
                <CButton color="secondary" class="ml-2" @click="closeModal">Отмена</CButton>
            </div>
        </CModal>
    </div>
</template>

<script>
import { CButton, CModal, CRow, CCol } from '@coreui/vue';
import AdsCampaignEventForm from './AdsCampaignEventForm.vue';

export default {
    name: 'AdsCampaignEventsList',
    components: {
        CButton,
        CModal,
        CRow,
        CCol,
        AdsCampaignEventForm,
    },
    props: {
        adsCampaignId: {
            type: Number,
            required: true,
        },
    },
    data() {
        return {
            events: [],
            isModalOpen: false,
            currentEvent: {},
        };
    },
    methods: {
        async fetchEvents() {
            try {
                const resp = await this.axios.get(`/ads-campaign-events?ads_id=${this.adsCampaignId}`);
                this.events = resp.data;
            } catch (error) {
                console.log(error);
                this.$root.$emit('showError', 'Ошибка загрузки событий.');
            }
        },
        openCreateModal() {
            this.currentEvent = {
                ads_id: this.adsCampaignId,
                current_date_title: '',
                current_date_times: [],
            };
            this.isModalOpen = true;
        },
        openEditModal(event) {
            this.currentEvent = { ...event };
            this.isModalOpen = true;
        },
        closeModal() {
            this.isModalOpen = false;
        },
        async handleSave(event) {
            try {
                if (!event.current_date_title) {
                    this.$root.$emit('showError', 'Введите дату мероприятия.');
                    return;
                }

                if (event.id) {
                    await this.axios.put(`/ads-campaign-events/${event.id}`, event);
                } else {
                    await this.axios.post('/ads-campaign-events', event);
                }
                this.closeModal();
                this.fetchEvents();
            } catch (error) {
                console.log(error);
                this.$root.$emit('showError', 'Ошибка сохранения события.');
            }
        },
        async deleteEvent(eventId) {
            if (confirm('Вы уверены, что хотите удалить это событие?')) {
                try {
                    await this.axios.delete(`/ads-campaign-events/${eventId}`);
                    this.fetchEvents();
                } catch (error) {
                    console.log(error);
                    this.$root.$emit('showError', 'Ошибка удаления события.');
                }
            }
        },
    },
    mounted() {
        this.fetchEvents();
    },
};
</script>
